import {
  SET_STOCK_OPNAMES,
  SET_STOCK_OPNAMES_ERROR,
  SET_STOCK_OPNAMES_LOADING,
} from "../../actions/stockOpnameAction";

const initialState = {
  datas: null,
  loading: false,
  error: null,
};

const stockOpnameReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_STOCK_OPNAMES:
      return {
        ...state,
        datas: action.data,
        error: null,
      };
    case SET_STOCK_OPNAMES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case SET_STOCK_OPNAMES_LOADING:
      return {
        ...state,
        loading: action.status,
      };
    default:
      return state;
  }
};

export default stockOpnameReducer;
